var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-file-input',{on:{"change":_vm.uploadFile},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}}),_c('v-btn',{on:{"click":_vm.getData}},[_vm._v("Teste fetch")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }